import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { StatusLdPageRoutingModule } from './status-ld-routing.module';
import { StatusLdPage } from './status-ld.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, StatusLdPageRoutingModule, TranslateModule.forChild()],
  declarations: [StatusLdPage]
})
export class StatusLdPageModule {}
